$(document).ready(function(){

    // new Swiper('.product-media', {
    //     loop: true,
    //     effect: 'fade',
    //     nextButton: '.swiper-button-next',
    //     prevButton: '.swiper-button-prev',
    //     slidesPerView: 2,
    //     paginationClickable: true,
    //     spaceBetween: 10,
           
    //     breakpoints: {
    //         1920: {
    //             slidesPerView: 1,
    //             spaceBetween: 10,
    //         },
    //         1028: {
    //             slidesPerView: 2,
    //             spaceBetween: 30
    //         },
    //         480: {
    //             slidesPerView: 1,
    //             spaceBetween: 10
    //         }
    //     }
    // });


var swiper = new Swiper('.product-media', {
    loop: true,
    effect: 'fade',
  allowTouchMove: true,

    paginationClickable: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
  
});

});

  function handleScroll() {
            const body = document.body;
            const scrollPosition = window.scrollY;

            
            const scrollThreshold = 100;

            if (scrollPosition >= scrollThreshold) {
              
                body.classList.add('scrolled');
            } else {
              
                body.classList.remove('scrolled');
            }
        }

        
        window.addEventListener('scroll', handleScroll);